import { createUseStyles } from 'react-jss';
import { colors } from '../../utils/theme';

export default createUseStyles({
  secondBarOption: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 8px',
    cursor: 'pointer',
    marginRight: '16px',
    color: colors.primary60,
    '&>svg': {
      marginTop: '2px',
      marginLeft: '6px',
      '&>path': {
        fill: colors.primary60,
      },
    },
    '&>p': {
      fontWeight: 600,
      color: colors.primary60,
    },
    '&:hover': {
      '&>p': {
        color: colors.primary80,
      },
      '&>svg': {
        '&>path': {
          fill: colors.primary80,
        },
      },
    },
  },
  secondBarOptionSelected: {
    '&>p': {
      color: colors.primary80,
    },
    '&>svg': {
      '&>path': {
        fill: colors.primary80,
      },
    },
  },
  mobileOptionSelectedOrDropdownOptionSelected: {
    color: colors.primary,
    fontWeight: 600,
    '&>svg': {
      '&>path': {
        fill: `${colors.primary} !important`,
      },
    },
  },
});
